module.exports = __webpack_public_path__ + "img/hatch_chart.79653e0f.png";